import createIcon from '../../createIcon';

/**
 * @component @name BuildCircle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTYuOSAxNS40OUwxNS41IDE2Ljg5QzE1LjMgMTcuMDkgMTQuOTkgMTcuMDkgMTQuNzkgMTYuODlMMTEuMzggMTMuNDhDMTAuMTYgMTMuOTEgOC43NCAxMy42NSA3Ljc2IDEyLjY3QzYuNjUgMTEuNTYgNi40NiA5Ljg4IDcuMTcgOC41N0w5LjUyIDEwLjkyTDEwLjkzIDkuNTFMOC41OCA3LjE3QzkuOSA2LjQ2IDExLjU3IDYuNjUgMTIuNjggNy43NkMxMy42NiA4Ljc0IDEzLjkyIDEwLjE2IDEzLjQ5IDExLjM4TDE2LjkgMTQuNzlDMTcuMDkgMTQuOTggMTcuMDkgMTUuMyAxNi45IDE1LjQ5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BuildCircle = createIcon('BuildCircle', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.9 15.49L15.5 16.89C15.3 17.09 14.99 17.09 14.79 16.89L11.38 13.48C10.16 13.91 8.74 13.65 7.76 12.67C6.65 11.56 6.46 9.88 7.17 8.57L9.52 10.92L10.93 9.51L8.58 7.17C9.9 6.46 11.57 6.65 12.68 7.76C13.66 8.74 13.92 10.16 13.49 11.38L16.9 14.79C17.09 14.98 17.09 15.3 16.9 15.49Z',
      key: '1681lz',
    },
  ],
]);

export default BuildCircle;
